function PartnerCollaboratorsSlider(el) {
    this.el = el;
    this.partnerEls = this.el.querySelectorAll('li');
    this.partnerElQueue = [...this.el.querySelectorAll('li.hidden')];
    this.nextIndex = 0;

    // Start the interval when there are more than 6 partners
    if (this.partnerEls.length > 6) setInterval(_ => this.pickRandomVisibleEl(), 3000);
}

PartnerCollaboratorsSlider.prototype.pickRandomVisibleEl = function() {
    const nextItemEl = this.partnerElQueue.shift();
    const currentItemEl = this.partnerEls[this.nextIndex];
    const currentItemClone = currentItemEl.cloneNode(true);

    // Add the cloned element to the end of the queue
    currentItemClone.classList.remove('visible');
    currentItemClone.classList.add('hidden');
    this.partnerElQueue.push(currentItemClone);

    // Replace the next item with the current item
    gsap.timeline()
        .to(currentItemEl, 0.5, { opacity: 0, ease: Power2.inOut })
        .add(_ => currentItemEl.innerHTML = nextItemEl.innerHTML)
        .to(currentItemEl, 0.5, { opacity: 1, ease: Power2.inOut })
    ;

    this.nextIndex++;
    if (this.nextIndex > 5) this.nextIndex = 0;
};

(function() {
    const sliders = document.querySelectorAll('.jsPartnersCollaborators');
    [...sliders].forEach(el => new PartnerCollaboratorsSlider(el));
})();